import React from 'react';
import { Grid } from '@mui/material';
import Input from 'components/Input';
import Dropdown from 'components/Dropdown';
import InputMask from 'components/InputMask';
import VirtualDrop from 'components/VirtualDrop';

const Filter = ({ grid, control, drops }) => {
  const checkDisplay = (name) => {
    const column = grid?.colunas?.find((c) => c?.field === name);
    if (column?.filterable) {
      return true;
    }
    return false;
  };

  return (
    <Grid container spacing={2}>
      {checkDisplay('id') && (
        <Grid item xs={12}>
          <Input name="id" control={control} label="ID" type="number" />
        </Grid>
      )}
      {checkDisplay('entidade') && (
        <Grid item xs={12}>
          <VirtualDrop
            name="entidade"
            control={control}
            label="Entidade"
            options={drops?.Entidade}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('dtvenc') && (
        <Grid item xs={6}>
          <InputMask
            name="dtvenc.i"
            control={control}
            label="Data de Vencimento Inicial"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('dtvenc') && (
        <Grid item xs={6}>
          <InputMask
            name="dtvenc.f"
            control={control}
            label="Data de Vencimento Final"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('documento') && (
        <Grid item xs={12}>
          <Input name="documento" control={control} label="Nº do Documento" />
        </Grid>
      )}
      {checkDisplay('parcela') && (
        <Grid item xs={12}>
          <Input
            name="parcela"
            control={control}
            label="Parcela"
            type="number"
          />
        </Grid>
      )}
      {checkDisplay('valor') && (
        <Grid item xs={12}>
          <InputMask name="valor" control={control} label="Valor Total" />
        </Grid>
      )}
      {checkDisplay('valor_baixado') && (
        <Grid item xs={12}>
          <InputMask
            name="valor_baixado"
            control={control}
            label="Valor Baixado"
          />
        </Grid>
      )}
      {checkDisplay('valor_pendente') && (
        <Grid item xs={12}>
          <InputMask
            name="valor_pendente"
            control={control}
            label="Valor Pendente"
          />
        </Grid>
      )}
      {checkDisplay('valor_outros') && (
        <Grid item xs={12}>
          <InputMask
            name="valor_outros"
            control={control}
            label="Valor Outros"
          />
        </Grid>
      )}
      {checkDisplay('forma_pagto') && (
        <Grid item xs={12}>
          <Dropdown
            name="forma_pagto"
            control={control}
            label="Forma de Pagamento"
            options={drops?.FormaDePagamento?.filter(
              (f) => f?.modulo !== 'VENDAS' && f?.modulo !== 'CHEQUES'
            )}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('filial') && (
        <Grid item xs={12}>
          <Dropdown
            name="filial"
            control={control}
            label="Filial"
            options={drops?.Filial}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('dtemissao') && (
        <Grid item xs={6}>
          <InputMask
            name="dtemissao.i"
            control={control}
            label="Data de Emissão Inicial"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('dtemissao') && (
        <Grid item xs={6}>
          <InputMask
            name="dtemissao.f"
            control={control}
            label="Data de Emissão Final"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('dtentrada') && (
        <Grid item xs={6}>
          <InputMask
            name="dtentrada.i"
            control={control}
            label="Data de Entrada Inicial"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('dtentrada') && (
        <Grid item xs={6}>
          <InputMask
            name="dtentrada.f"
            control={control}
            label="Data de Entrada Final"
            type="date"
          />
        </Grid>
      )}
      {checkDisplay('observacao') && (
        <Grid item xs={12}>
          <Input name="observacao" control={control} label="Observação" />
        </Grid>
      )}
    </Grid>
  );
};

export default Filter;
